import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import UserCard from "shared/components/UserCard";
import UserCardPlaceholder from "shared/components/UserCardPlaceholder";

import UserWrapper from "apps/discovery/containers/user/UserWrapper";

import "./PhotoAndText.scss";

const PhotoAndText = (props) => {
	const { user, placeholder } = props;

	const userClasses = {
		"user-photoAndText": true,
		"isPlaceholder": placeholder,
	};

	if (placeholder) {
		return (
			<div className={classnames(userClasses)}>
				<UserCardPlaceholder />
			</div>
		);
	}

	return (
		<UserWrapper className={classnames(userClasses)} {...props}>
			<UserCard {...user} shouldDisablePopover />
		</UserWrapper>
	);
};

PhotoAndText.propTypes = {
	user: PropTypes.object,
	placeholder: PropTypes.bool,
};

export default PhotoAndText;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/user/PhotoAndText.jsx